<template>
  <div class="step-one">
    <div class="row">
      <div class="field">
        <VueSuggestions
            ref="surname"
            :model.sync="userData.patientSurname"
            placeholder="Фамилия"
            :options="suggestionSurname"
            @focused="onFocus"
            @update:model="validate()"
            :class="['input', {'is-error': validState.patientSurname === false}]"
        />
      </div>

      <div class="field">
        <VueSuggestions
            ref="name"
            :model.sync="userData.patientName"
            placeholder="Имя"
            :options="suggestionName"
            :class="['input', {'is-error': validState.patientName === false}]"
            @update:model="validate()"
        />
      </div>

      <div class="field">
        <VueSuggestions
            ref="patronymic"
            :model.sync="userData.patientPatronymic"
            placeholder="Отчество"
            :options="suggestionPatronymic"
            :class="['input', {'is-error': validState.patientPatronymic === false}]"
            @update:model="validate()"
        />
      </div>
    </div>
    <div class="row">
      <AgeInput @setDate="setDate" :valid-state="validState.patientBirthDate"/>
      <div class="field">
        <button
            @click="sendUserData"
            class="button">
          Далее
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import VueSuggestions from 'vue-suggestions';
  import AgeInput from './AgeInput';

  export default {
    name: "step-one",
    props: [
      'userData'
    ],
    components: {
      VueSuggestions,
      AgeInput
    },
    data(){
      return {
        suggestionName: {
          token: 'ecf3b29fd67c6e155d574d9f1d4f1c566b570e50',
          type: "NAME",
          params: {
            parts: ["NAME"]
          }
        },
        suggestionSurname: {
          token: 'ecf3b29fd67c6e155d574d9f1d4f1c566b570e50',
          type: "NAME",
          params: {
            parts: ["SURNAME"]
          }
        },
        suggestionPatronymic: {
          token: 'ecf3b29fd67c6e155d574d9f1d4f1c566b570e50',
          type: "NAME",
          params: {
            parts: ["PATRONYMIC"]
          }
        },
        validState: {
          patientName: null,
          patientSurname: null,
          patientPatronymic: null,
          patientBirthDate: null,
        },
      }
    },
    computed:{
      isValid(){
        for (let key in this.userData){
          if(this.validState[key] === false){
            return false;
          }
        }
        return true;
      }
    },
    methods: {
      setDate(date) {
        this.userData.patientBirthDate = date;
        if(this.validState.patientBirthDate !== null){
          this.validate();
        }
      },
      sendUserData() {
        this.validate();
        if(this.isValid){
          this.$emit('sendUserData');
        }
      },
      onFocus() {
        console.log(this.$refs.input.$el);
      },
      validate(){
        ['patientName', 'patientSurname', 'patientPatronymic'].forEach(key => {
          this.validState[key] = this.userData[key] !== '';
        });
        this.validState.patientBirthDate = this.userData.patientBirthDate !== 'Invalid date';
      },
      revalidate(key){
        this.validState[key] = this.userData[key] !== '';
      }
    },
    mounted() {
      const refKeys = Object.values(this.$refs);
      for (let input of refKeys) {
        input.$el.addEventListener('focus', (event) => {
          event.preventDefault();
          event.target.scrollIntoView({ block: "center", inline: "nearest"});
        });
      }
    }
  }
</script>

<style scoped lang="sass">
  .step-one
    padding: 40px 0
    max-height: 559px
    width: 100%

    .row
      display: flex

      @media all and (max-width: 768px)
        flex-direction: column

    .field
      margin-bottom: 20px
      position: relative
      flex: 0 0 calc(33.33% - 10px)

      &:not(:last-child)
        margin-right: 20px

      @media all and (max-width: 768px)
        flex: 1 0 100%
        &:not(:last-child)
          margin-right: 0

    .button
      text-transform: uppercase
      line-height: 64%
      font-weight: 500
      border-radius: 4px
      width: 220px
</style>

